// 配置echart统计图的文字、图片等自适应通用方法
export default{
  // echart 图表自适应
  chartResize(myChart) {
      setTimeout(() => {
        myChart.resize()
      }, 1000)
  },
  // echart文字自适应
  textResize(fontSize){
    const width = window.screen.width
    const ratio = width / 5760
    // console.log(parseInt(fontSize * ratio))
    // return parseInt(fontSize * ratio) > 12 ?parseInt(fontSize * ratio)+'px' :'12px'
    return parseInt(fontSize * ratio) +'px'
  }
}
 